export default "__VITE_ASSET__BtoY3_uz__"